import { render, staticRenderFns } from "./super-marketcrash-filter.vue?vue&type=template&id=185ba1dc"
import script from "./super-marketcrash-filter.vue?vue&type=script&lang=js"
export * from "./super-marketcrash-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports